import React, { useState } from 'react';
import { useLocation } from 'react-router-dom';
import { toast } from 'react-toastify';
import { KTSVG } from 'src/_metronic/helpers';
import SupportFeedbackModal from './SupportFeedbackModal';

// Footer'ın (bottombar) sol sabit ikon grubunda yaşar — Footer.tsx'te monte edilir.
const SupportFeedbackButton: React.FC = () => {
  const location = useLocation();
  const [open, setOpen] = useState(false);
  const [capturing, setCapturing] = useState(false);
  const [screenshot, setScreenshot] = useState<string | null>(null);

  const captureAndOpen = async () => {
    setCapturing(true);
    // FAB'ın gizlenmesi için bir kare bekle, sonra ekranı yakala
    await new Promise((r) => setTimeout(r, 60));
    try {
      const html2canvas = (await import('html2canvas')).default;
      const canvas = await html2canvas(document.body, {
        useCORS: true,
        allowTaint: true,
        logging: false,
        backgroundColor: '#ffffff',
        scale: window.devicePixelRatio > 1 ? 2 : 1,
        x: window.scrollX,
        y: window.scrollY,
        width: window.innerWidth,
        height: window.innerHeight,
        windowWidth: document.documentElement.scrollWidth,
        windowHeight: document.documentElement.scrollHeight,
        ignoreElements: (el: Element) => (el as HTMLElement)?.getAttribute?.('data-feedback-ignore') === 'true',
      });
      setScreenshot(canvas.toDataURL('image/jpeg', 0.9));
    } catch (e) {
      // Yakalama başarısız olsa da talep oluşturulabilsin
      setScreenshot(null);
      toast.info('Ekran görüntüsü alınamadı, talebinizi görüntüsüz oluşturabilirsiniz.');
    } finally {
      setCapturing(false);
      setOpen(true);
    }
  };

  const handleClose = () => {
    setOpen(false);
    setScreenshot(null);
  };

  return (
    <>
      {/* Yakalama sırasında ince bir gösterge */}
      {capturing && (
        <div
          data-feedback-ignore="true"
          style={{ position: 'fixed', inset: 0, zIndex: 2000, pointerEvents: 'none', display: 'flex', alignItems: 'center', justifyContent: 'center' }}
        >
          <div className="bg-dark bg-opacity-75 text-white px-4 py-2 rounded-pill shadow-lg d-flex align-items-center">
            <span className="spinner-border spinner-border-sm me-2" />
            Ekran görüntüsü alınıyor...
          </div>
        </div>
      )}

      <button
        data-feedback-ignore="true"
        type="button"
        className="footer-sticky-icon footer-sticky-icon--warning"
        title="Destek talebi oluştur / geri bildirim gönder"
        onClick={captureAndOpen}
        disabled={capturing || open}
      >
        <KTSVG path="/media/icons/duotone/Code/Question-circle.svg" className="footer-sticky-icon__svg" />
      </button>

      <SupportFeedbackModal show={open} onClose={handleClose} screenshot={screenshot} pageUrl={location.pathname} />
    </>
  );
};

export default SupportFeedbackButton;
